import React from 'react';
import '../../assets/css/pagination.css';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  return (
    <div id='Pagination'>
        <div className='PaginationMain'>
          {pages.map((page) => (
            <div 
              key={page}
              className={`PaginationBox ${currentPage === page ? 'active' : ''}`}
              onClick={() => onPageChange(page)}
            >
              <p>{page}</p>
            </div>
          ))}
        </div>
      </div>
  );
};

export default Pagination;